<template>
    <div>
        <PullContainer
            ref="pullContainerRef"
            :pullDownLoading="true"
            :pullDownLabel="true"
            @pullDownLoadingSuccess="pullDownLoadingSuccess"
        >
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
                    </div>
                    <div class="mobile_container invoice_management_container">
                        <div class="mobile_container_list">
                            <ul v-infinite-scroll="onLoadList">
                                <li class="payable_list_item" v-for="(row, index) in tableData" :key="index">
                                    <div class="payable_list_item_top">
                                        <div>
                                            <span class="link-label" @click="handleClickInvoiceDetail(row)">{{
                                                row.invoice_no
                                            }}</span>
                                            <span
                                                class="handle_icon_wrap"
                                                v-if="row.invalid_time"
                                                @click="handleClickInvalidReasonLook(row)"
                                            >
                                                <i class="iconfont icon-quxiaokaohe"></i>
                                            </span>
                                        </div>
                                        <span>{{ row.invoice_time }}</span>
                                    </div>
                                    <div class="payable_list_item_content">
                                        <div class="payable_list_item_amount">
                                            <div>
                                                <div class="payable_list_item_amount_percent percent_bg1">
                                                    开票金额：¥{{ row.invoice_amount }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </template>
        </PullContainer>
        <!-- 作废原因展示弹框 -->
        <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }" :show="invalidReasonLookDialog">
            <div class="custom_overlay_content">
                <div class="custom_overlay_content_title">
                    <span>作废原因</span>
                    <van-icon name="cross" @click="handleClickInvalidReasonLookClose" />
                </div>
                <div class="custom_overlay_content_form">
                    <van-field v-model="invalid_reason" autosize label="" type="textarea" />
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
export default {
    name: "InvoiceRecord",
    components: { PullContainer, ReturnNavBar },
    data() {
        return {
            tableData: [
                {
                    invoice_no: "ABv1111",
                    invoice_time: "2024-09-18  14:52",
                    invalid_time: "2024",
                    invalid_reason: "作废原因2222",
                },
                {
                    invoice_no: "ABv2222",
                    invoice_time: "2024-09-18  14:52",
                    invalid_time: "2024",
                    invalid_reason: "作废原因111",
                },
            ],
            // 作废原因弹框
            invalid_reason: "",
            invalidReasonLookDialog: false,
        };
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                setTimeout(() => {
                    this.$refs.pullContainerRef.pullDownLoadingEnd();
                }, 3000);
            }
        },
        // 作废原因查看弹框
        handleClickInvalidReasonLook(row) {
            this.invalid_reason = row.invalid_reason;
            this.invalidReasonLookDialog = true;
        },
        handleClickInvalidReasonLookClose() {
            this.invalidReasonLookDialog = false;
            this.invalid_reason = "";
        },
        // 详情
        handleClickInvoiceDetail(row) {
            this.$router.push({
                name: "InvoiceDetails",
                query: {
                    invoice_no: row.invoice_no,
                },
            });
        },
        onLoadList() {},
    },
};
</script>
<style lang="scss" scoped>
.invoice_management_container {
    .mobile_container_list {
        padding: 10px 16px;
        .payable_list_item {
            width: 100%;
            padding: 12px;
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            margin-bottom: 10px;
            .payable_list_item_top {
                margin-bottom: 8px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                color: rgba(153, 153, 153, 1);
                & > div {
                    display: flex;
                    align-items: center;
                }
                .link-label {
                    font-size: 14px;
                    line-height: 22px;
                    color: rgba(41, 144, 255, 1);
                }
            }
            .payable_list_item_content {
                .payable_list_item_amount {
                    width: 100%;
                    padding: 4px;
                    border-radius: 4px;
                    background: #ffffff;
                    border: 2px solid rgba(237, 240, 244, 1);
                    & > div {
                        height: 24px;
                        display: flex;
                        justify-content: space-between;
                        gap: 4px;
                    }
                    & > div + div {
                        margin-top: 4px;
                    }
                    .payable_list_item_amount_percent {
                        width: 100%;
                        height: 24px;
                        padding: 0 8px;
                        font-size: 12px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 24px;
                        color: rgba(102, 102, 102, 1);
                        border-radius: 4px;
                        box-sizing: border-box;
                    }
                    .percent_bg1 {
                        background-color: rgba(41, 144, 255, 0.16);
                    }
                }
            }
            .handle_icon_wrap {
                margin-left: 4px;
                color: rgba(228, 65, 68, 1);
            }
        }
    }
}
</style>
